import { defineFilterSpec, multiField, rangeField, text } from '@/lib/api/filter-spec';

import type { SubscriptionsReportFilterFormValues, SubscriptionsReportListFilters } from './types';

/** Single declaration of the Subscriptions report's list params, shared by `api.ts`, the filter
 *  drawer and the page's export config — so the grid, the panel and the downloaded file can never
 *  disagree about what is applied.
 *
 *  `multiField` joins the selected ids to a comma string on the wire (the repo-wide convention the
 *  shipped Orders and Customers listings already send to a real backend); `rangeField` emits the
 *  `…From`/`…To` pair the backend DTO declares. Field order here is irrelevant to the wire — the
 *  panel's visual order lives in the drawer. */
const spec = defineFilterSpec<SubscriptionsReportListFilters, SubscriptionsReportFilterFormValues>([
  text('search'),
  multiField('customerIds'),
  rangeField('totalDevices'),
  rangeField('expiringIn30Days'),
]);

export const toListQuery = spec.toListQuery;
export const toDefaults = spec.toDefaults;
export const toFilters = spec.toFilters;
/** Search deliberately does NOT count as an active filter (it has its own control), so the Filter
 *  button's dot reflects the panel alone. A `0` bound DOES count — `From = 0` is a real filter. */
export const hasActiveFilters = spec.hasActiveFilters;
